// extracted by mini-css-extract-plugin
module.exports = {"ListItem":"AccordionList_ListItem__1FOKg","Item":"AccordionList_Item__1wDnv"};